import { parsePhoneNumber } from 'libphonenumber-js';

// Mapeo de códigos de país a emojis de banderas
const countryFlags = {
  'AR': '🇦🇷', // Argentina
  'BR': '🇧🇷', // Brasil
  'MX': '🇲🇽', // México
  'US': '🇺🇸', // Estados Unidos
  'ES': '🇪🇸', // España
  'CO': '🇨🇴', // Colombia
  'CL': '🇨🇱', // Chile
  'PE': '🇵🇪', // Perú
  'VE': '🇻🇪', // Venezuela
  'EC': '🇪🇨', // Ecuador
  'BO': '🇧🇴', // Bolivia
  'PY': '🇵🇾', // Paraguay
  'UY': '🇺🇾', // Uruguay
  'GT': '🇬🇹', // Guatemala
  'CU': '🇨🇺', // Cuba
  'DO': '🇩🇴', // República Dominicana
  'HN': '🇭🇳', // Honduras
  'NI': '🇳🇮', // Nicaragua
  'SV': '🇸🇻', // El Salvador
  'CR': '🇨🇷', // Costa Rica
  'PA': '🇵🇦', // Panamá
  'PR': '🇵🇷', // Puerto Rico
  'CA': '🇨🇦', // Canadá
  'GB': '🇬🇧', // Reino Unido
  'FR': '🇫🇷', // Francia
  'DE': '🇩🇪', // Alemania
  'IT': '🇮🇹', // Italia
  'PT': '🇵🇹', // Portugal
  'NL': '🇳🇱', // Países Bajos
  'BE': '🇧🇪', // Bélgica
  'CH': '🇨🇭', // Suiza
  'AT': '🇦🇹', // Austria
  'SE': '🇸🇪', // Suecia
  'NO': '🇳🇴', // Noruega
  'DK': '🇩🇰', // Dinamarca
  'FI': '🇫🇮', // Finlandia
  'PL': '🇵🇱', // Polonia
  'RU': '🇷🇺', // Rusia
  'CN': '🇨🇳', // China
  'JP': '🇯🇵', // Japón
  'KR': '🇰🇷', // Corea del Sur
  'IN': '🇮🇳', // India
  'AU': '🇦🇺', // Australia
  'NZ': '🇳🇿', // Nueva Zelanda
  'ZA': '🇿🇦', // Sudáfrica
  'EG': '🇪🇬', // Egipto
  'NG': '🇳🇬', // Nigeria
  'KE': '🇰🇪', // Kenia
  'MA': '🇲🇦', // Marruecos
  'IL': '🇮🇱', // Israel
  'AE': '🇦🇪', // Emiratos Árabes Unidos
  'SA': '🇸🇦', // Arabia Saudita
  'TR': '🇹🇷', // Turquía
  'GR': '🇬🇷', // Grecia
  'IE': '🇮🇪', // Irlanda
  'CZ': '🇨🇿', // República Checa
  'RO': '🇷🇴', // Rumania
  'HU': '🇭🇺', // Hungría
  'BG': '🇧🇬', // Bulgaria
  'HR': '🇭🇷', // Croacia
  'RS': '🇷🇸', // Serbia
  'UA': '🇺🇦', // Ucrania
  'PH': '🇵🇭', // Filipinas
  'ID': '🇮🇩', // Indonesia
  'MY': '🇲🇾', // Malasia
  'SG': '🇸🇬', // Singapur
  'TH': '🇹🇭', // Tailandia
  'VN': '🇻🇳', // Vietnam
  'PK': '🇵🇰', // Pakistán
  'BD': '🇧🇩', // Bangladesh
  'LK': '🇱🇰', // Sri Lanka
};

// Country names in Spanish (kept for Argentina localization)
const countryNames = {
  'AR': 'Argentina',
  'BR': 'Brasil',
  'MX': 'México',
  'US': 'Estados Unidos',
  'ES': 'España',
  'CO': 'Colombia',
  'CL': 'Chile',
  'PE': 'Perú',
  'VE': 'Venezuela',
  'EC': 'Ecuador',
  'BO': 'Bolivia',
  'PY': 'Paraguay',
  'UY': 'Uruguay',
  'GT': 'Guatemala',
  'CU': 'Cuba',
  'DO': 'República Dominicana',
  'HN': 'Honduras',
  'NI': 'Nicaragua',
  'SV': 'El Salvador',
  'CR': 'Costa Rica',
  'PA': 'Panamá',
  'PR': 'Puerto Rico',
  'CA': 'Canadá',
  'GB': 'Reino Unido',
  'FR': 'Francia',
  'DE': 'Alemania',
  'IT': 'Italia',
  'PT': 'Portugal',
  'NL': 'Países Bajos',
  'BE': 'Bélgica',
  'CH': 'Suiza',
  'AT': 'Austria',
  'SE': 'Suecia',
  'NO': 'Noruega',
  'DK': 'Dinamarca',
  'FI': 'Finlandia',
  'PL': 'Polonia',
  'RU': 'Rusia',
  'CN': 'China',
  'JP': 'Japón',
  'KR': 'Corea del Sur',
  'IN': 'India',
  'AU': 'Australia',
  'NZ': 'Nueva Zelanda',
  'ZA': 'Sudáfrica',
  'EG': 'Egipto',
  'NG': 'Nigeria',
  'KE': 'Kenia',
  'MA': 'Marruecos',
  'IL': 'Israel',
  'AE': 'Emiratos Árabes Unidos',
  'SA': 'Arabia Saudita',
  'TR': 'Turquía',
  'GR': 'Grecia',
  'IE': 'Irlanda',
  'CZ': 'República Checa',
  'RO': 'Rumania',
  'HU': 'Hungría',
  'BG': 'Bulgaria',
  'HR': 'Croacia',
  'RS': 'Serbia',
  'UA': 'Ucrania',
  'PH': 'Filipinas',
  'ID': 'Indonesia',
  'MY': 'Malasia',
  'SG': 'Singapur',
  'TH': 'Tailandia',
  'VN': 'Vietnam',
  'PK': 'Pakistán',
  'BD': 'Bangladesh',
  'LK': 'Sri Lanka',
};

/**
 * Gets country information based on phone number
 * @param {string} phoneNumber - Phone number with country code
 * @returns {object} - Objeto con flag (emoji), countryCode y countryName
 */
export const getPhoneCountryInfo = (phoneNumber) => {
  if (!phoneNumber) {
    return { flag: '🌍', countryCode: null, countryName: 'Desconocido', formattedNumber: '' };
  }

  try {
    // Asegurarse de que el número tenga el formato correcto con +
    let formattedNumber = phoneNumber.toString().trim();
    
    // Si el número ya tiene + al inicio, intentar parsearlo directamente
    if (formattedNumber.startsWith('+')) {
      const parsed = parsePhoneNumber(formattedNumber);
      if (parsed && parsed.country) {
        const countryCode = parsed.country;
        return {
          flag: countryFlags[countryCode] || '🌍',
          countryCode: countryCode,
          countryName: countryNames[countryCode] || countryCode,
          formattedNumber: parsed.formatInternational()
        };
      }
    }
    
    // Detección manual por prefijos comunes
    const phoneStr = formattedNumber;
    
    // Argentina - varios formatos posibles
    if (phoneStr.startsWith('549') && phoneStr.length >= 13) {
      // Formato con 9 después del código de país (WhatsApp)
      // Verificar que no sea 54 9X donde X es 1-9 (sería otro país)
      const afterCode = phoneStr.slice(3);
      if (afterCode.startsWith('1') && afterCode.length === 10) {
        // Es un número argentino de Buenos Aires
        formattedNumber = '+' + phoneStr;
        try {
          const parsed = parsePhoneNumber(formattedNumber);
          if (parsed) {
            return {
              flag: '🇦🇷',
              countryCode: 'AR',
              countryName: 'Argentina',
              formattedNumber: parsed.formatInternational()
            };
          }
        } catch {
          // Formatear manualmente
          const areaCode = phoneStr.substring(3, 5);
          const number = phoneStr.substring(5);
          return {
            flag: '🇦🇷',
            countryCode: 'AR',
            countryName: 'Argentina',
            formattedNumber: `+54 (9${areaCode}) ${number.slice(0, 4)}-${number.slice(4)}`
          };
        }
      } else if (!afterCode.startsWith('1') && !afterCode.startsWith('0')) {
        // Otros códigos de área de Argentina
        formattedNumber = '+' + phoneStr;
        try {
          const parsed = parsePhoneNumber(formattedNumber);
          if (parsed) {
            return {
              flag: '🇦🇷',
              countryCode: 'AR',
              countryName: 'Argentina',
              formattedNumber: parsed.formatInternational()
            };
          }
        } catch {
          return {
            flag: '🇦🇷',
            countryCode: 'AR',
            countryName: 'Argentina',
            formattedNumber: `+54 9 ${phoneStr.slice(3)}`
          };
        }
      }
    }
    
    // Verificar si es un número con código 54 pero que podría ser USA mal formateado
    if (phoneStr.startsWith('5491') && phoneStr.length === 14) {
      // Podría ser +54 91 70999944477 (Argentina) o un error
      // Si después del 5491 viene un 7, probablemente sea USA (1-709...)
      if (phoneStr[4] === '7') {
        // Es probable que sea un número de USA mal formateado
        const usNumber = phoneStr.slice(3); // Quitar '549' y dejar '17099994477'
        return { 
          flag: '🇺🇸', 
          countryCode: 'US', 
          countryName: 'Estados Unidos/Canadá', 
          formattedNumber: `+1 ${usNumber.slice(1, 4)} ${usNumber.slice(4, 7)} ${usNumber.slice(7)}` 
        };
      }
    }
    
    if (phoneStr.startsWith('54') && phoneStr.length >= 12 && !phoneStr.startsWith('549')) {
      formattedNumber = '+' + phoneStr;
      try {
        const parsed = parsePhoneNumber(formattedNumber);
        if (parsed) {
          return {
            flag: '🇦🇷',
            countryCode: 'AR',
            countryName: 'Argentina',
            formattedNumber: parsed.formatInternational()
          };
        }
      } catch {
        return {
          flag: '🇦🇷',
          countryCode: 'AR',
          countryName: 'Argentina',
          formattedNumber: `+${phoneStr.slice(0, 2)} ${phoneStr.slice(2, 4)} ${phoneStr.slice(4, 8)} ${phoneStr.slice(8)}`
        };
      }
    }
    
    // USA/Canadá - Si empieza con 1 y tiene 11 dígitos, es norteamericano
    if (phoneStr.startsWith('1') && phoneStr.length === 11) {
      // Verificar que el segundo dígito no sea 1 (sería código de área válido de USA/Canadá)
      const areaCode = phoneStr.slice(1, 4);
      if (areaCode[0] >= '2' && areaCode[0] <= '9') {
        return { 
          flag: '🇺🇸', 
          countryCode: 'US', 
          countryName: 'Estados Unidos/Canadá', 
          formattedNumber: `+1 (${areaCode}) ${phoneStr.slice(4, 7)}-${phoneStr.slice(7)}` 
        };
      }
    }
    
    // Argentina - números locales que empiezan con 11 (Buenos Aires)
    if (phoneStr.startsWith('11') && (phoneStr.length === 10 || phoneStr.length === 11)) {
      const fullNumber = '+549' + phoneStr;
      try {
        const parsed = parsePhoneNumber(fullNumber);
        if (parsed) {
          return {
            flag: '🇦🇷',
            countryCode: 'AR',
            countryName: 'Argentina',
            formattedNumber: parsed.formatInternational()
          };
        }
      } catch {
        return {
          flag: '🇦🇷',
          countryCode: 'AR',
          countryName: 'Argentina',
          formattedNumber: `+54 (911) ${phoneStr.slice(-8, -4)}-${phoneStr.slice(-4)}`
        };
      }
    }
    
    // Otros países
    if (phoneStr.startsWith('52')) {
      // México - formato: +52 (xxx) xxxx-xxxx
      const mexicoNumber = phoneStr.length > 12 ? 
        `+52 (${phoneStr.slice(2, 5)}) ${phoneStr.slice(5, 9)}-${phoneStr.slice(9)}` :
        `+52 (${phoneStr.slice(2, 5)}) ${phoneStr.slice(5, 9)}-${phoneStr.slice(9)}`;
      return { flag: '🇲🇽', countryCode: 'MX', countryName: 'México', formattedNumber: mexicoNumber };
    }
    if (phoneStr.startsWith('55')) {
      // Brasil - formato: +55 (xx) xxxxx-xxxx
      const brasilNumber = `+55 (${phoneStr.slice(2, 4)}) ${phoneStr.slice(4, 9)}-${phoneStr.slice(9)}`;
      return { flag: '🇧🇷', countryCode: 'BR', countryName: 'Brasil', formattedNumber: brasilNumber };
    }
    if (phoneStr.startsWith('34')) {
      // España - formato: +34 (xxx) xxx-xxx
      const spainNumber = `+34 (${phoneStr.slice(2, 5)}) ${phoneStr.slice(5, 8)}-${phoneStr.slice(8)}`;
      return { flag: '🇪🇸', countryCode: 'ES', countryName: 'España', formattedNumber: spainNumber };
    }
    if (phoneStr.startsWith('573')) {
      // Colombia móvil - formato: +57 (3xx) xxx-xxxx
      const colombiaNumber = `+57 (${phoneStr.slice(2, 5)}) ${phoneStr.slice(5, 8)}-${phoneStr.slice(8)}`;
      return { flag: '🇨🇴', countryCode: 'CO', countryName: 'Colombia', formattedNumber: colombiaNumber };
    }
    if (phoneStr.startsWith('57')) {
      // Colombia - formato: +57 (x) xxx-xxxx
      const colombiaNumber = `+57 (${phoneStr.slice(2, 3)}) ${phoneStr.slice(3, 6)}-${phoneStr.slice(6)}`;
      return { flag: '🇨🇴', countryCode: 'CO', countryName: 'Colombia', formattedNumber: colombiaNumber };
    }
    if (phoneStr.startsWith('56')) {
      // Chile - formato: +56 (x) xxxx-xxxx
      const chileNumber = `+56 (${phoneStr.slice(2, 3)}) ${phoneStr.slice(3, 7)}-${phoneStr.slice(7)}`;
      return { flag: '🇨🇱', countryCode: 'CL', countryName: 'Chile', formattedNumber: chileNumber };
    }
    if (phoneStr.startsWith('51') && phoneStr.length >= 11) {
      // Perú - formato: +51 (xxx) xxx-xxx
      const peruNumber = `+51 (${phoneStr.slice(2, 5)}) ${phoneStr.slice(5, 8)}-${phoneStr.slice(8)}`;
      return { flag: '🇵🇪', countryCode: 'PE', countryName: 'Perú', formattedNumber: peruNumber };
    }
    if (phoneStr.startsWith('598')) {
      // Uruguay - formato: +598 (xx) xxx-xxx
      const uruguayNumber = `+598 (${phoneStr.slice(3, 5)}) ${phoneStr.slice(5, 8)}-${phoneStr.slice(8)}`;
      return { flag: '🇺🇾', countryCode: 'UY', countryName: 'Uruguay', formattedNumber: uruguayNumber };
    }
    if (phoneStr.startsWith('593')) {
      // Ecuador - formato: +593 (xx) xxx-xxxx
      const ecuadorNumber = `+593 (${phoneStr.slice(3, 5)}) ${phoneStr.slice(5, 8)}-${phoneStr.slice(8)}`;
      return { flag: '🇪🇨', countryCode: 'EC', countryName: 'Ecuador', formattedNumber: ecuadorNumber };
    }
    if (phoneStr.startsWith('595')) {
      // Paraguay - formato: +595 (xxx) xxx-xxx
      const paraguayNumber = `+595 (${phoneStr.slice(3, 6)}) ${phoneStr.slice(6, 9)}-${phoneStr.slice(9)}`;
      return { flag: '🇵🇾', countryCode: 'PY', countryName: 'Paraguay', formattedNumber: paraguayNumber };
    }
    if (phoneStr.startsWith('591')) {
      // Bolivia - formato: +591 (x) xxx-xxxx
      const boliviaNumber = `+591 (${phoneStr.slice(3, 4)}) ${phoneStr.slice(4, 7)}-${phoneStr.slice(7)}`;
      return { flag: '🇧🇴', countryCode: 'BO', countryName: 'Bolivia', formattedNumber: boliviaNumber };
    }
    if (phoneStr.startsWith('58')) {
      // Venezuela - formato: +58 (xxx) xxx-xxxx
      const venezuelaNumber = `+58 (${phoneStr.slice(2, 5)}) ${phoneStr.slice(5, 8)}-${phoneStr.slice(8)}`;
      return { flag: '🇻🇪', countryCode: 'VE', countryName: 'Venezuela', formattedNumber: venezuelaNumber };
    }
    if (phoneStr.startsWith('506')) {
      // Costa Rica - formato: +506 xxxx-xxxx
      const costaRicaNumber = `+506 ${phoneStr.slice(3, 7)}-${phoneStr.slice(7)}`;
      return { flag: '🇨🇷', countryCode: 'CR', countryName: 'Costa Rica', formattedNumber: costaRicaNumber };
    }
    if (phoneStr.startsWith('507')) {
      // Panamá - formato: +507 xxxx-xxxx
      const panamaNumber = `+507 ${phoneStr.slice(3, 7)}-${phoneStr.slice(7)}`;
      return { flag: '🇵🇦', countryCode: 'PA', countryName: 'Panamá', formattedNumber: panamaNumber };
    }
    
    // Si no se detecta, intentar con + al inicio
    if (!phoneStr.startsWith('+')) {
      formattedNumber = '+' + phoneStr;
      try {
        const parsed = parsePhoneNumber(formattedNumber);
        if (parsed && parsed.country) {
          const countryCode = parsed.country;
          return {
            flag: countryFlags[countryCode] || '🌍',
            countryCode: countryCode,
            countryName: countryNames[countryCode] || countryCode,
            formattedNumber: parsed.formatInternational()
          };
        }
      } catch {
        // Ignorar error
      }
    }
    
  } catch (error) {
    // Ignorar errores de parseo
  }

  // Por defecto, asumir Argentina si el número parece válido
  const phoneStr = phoneNumber.toString();
  if (phoneStr.length >= 10 && phoneStr.length <= 15) {
    return { 
      flag: '🇦🇷', 
      countryCode: 'AR', 
      countryName: 'Argentina', 
      formattedNumber: phoneStr 
    };
  }

  return { flag: '🌍', countryCode: null, countryName: 'Desconocido', formattedNumber: phoneNumber };
};

/**
 * Formats a phone number for display
 * @param {string} phoneNumber - Phone number
 * @returns {string} - Número formateado
 */
export const formatPhoneNumber = (phoneNumber) => {
  const info = getPhoneCountryInfo(phoneNumber);
  return info.formattedNumber || phoneNumber;
};
